'use client';

import useInstallPrompt from '@alltrails/install-prompt/hooks/useInstallPrompt';
import InstallBanner from '@alltrails/install-prompt/components/InstallBanner';
import { LocationDetailsPageProps } from '@/types/locationDetailsPages/shared';

export default function InstallBannerWrapper({ details }: Pick<LocationDetailsPageProps, 'details'>) {
  const [isBannerOpen, setIsBannerOpen] = useInstallPrompt('banner', true);
  const deeplinkData = details.parkInfo?.parkId ? { pageId: details.parkInfo?.parkId, pageType: 'area' } : {};

  return (
    <>
      <InstallBanner {...deeplinkData} isOpen={isBannerOpen} onRequestClose={() => setIsBannerOpen(false)} promptLocation="parks page" />
    </>
  );
}
